import { Col, Form } from "react-bootstrap";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import { DoubleBedIconSvg } from "../../../../assets/svg";
import { useCallback, useContext, useEffect, useState } from "react";
import SnackbarContext from "../../../../context/snackbar.context";
import React from "react";
// import CustomSelect from "../../../../components/CustomSelect/CustomSelect";
// import { getAvailableDeckRooms, getAvailableDecks } from "../../../../api/quotation.api";
import { debounce } from "lodash";
import { SelectedUserContext } from "../../../../context/selecteduser.context";

interface ICabinCard {
    cabinInfo: any;
    cabinCategoryData: any;
    setCabinCategoryData: any;
    payloadObj: any;
    specialPricingUpgradeOffer: { specialPricing: boolean, upgradeOffer: boolean }
}

const CabinCard: React.FC<ICabinCard> = (props) => {
  const snackbarCtx = useContext(SnackbarContext);
  const { addRemoveCabinLoader, handleAddRemoveCabinLoader, lastCabinUpdates, handleLastCabinUpdates } = useContext(SelectedUserContext);

  const { cabinInfo, cabinCategoryData, setCabinCategoryData, payloadObj, specialPricingUpgradeOffer } = props;
  const [addedCabinData, setAddedCabinData] = useState<any[]>([]);
  const [cabinSelected, setCabinSelected] = useState<boolean>(false);
  const [cabinConfigurationCount, setCabinConfigurationCount] = useState({ three_seater: 0, four_seater: 0 });
  // const [addedCabinDecksData, setAddedCabinDecksData] = useState<any>([]);
  // const [addedCabinDeckRoomsData, setAddedCabinDeckRoomsData] = useState<any>([]);

  useEffect(() => { 
    if(lastCabinUpdates.undo && lastCabinUpdates.lastCabinId === cabinInfo.room_category_id){
      handleCabinRemove();
      handleLastCabinUpdates(cabinInfo.room_category_id, false);
    }
  }, [lastCabinUpdates.undo]);

  const handleCabinSelect = () => {
    if (cabinSelected) {
      setAddedCabinData([]);
      // setAddedCabinDecksData([]);
      // setAddedCabinDeckRoomsData([]);
      const { [cabinInfo.room_category_id]: delCabin, ...tempObj } = cabinCategoryData;
      setCabinCategoryData({ ...tempObj });
      setCabinConfigurationCount({ three_seater: 0, four_seater: 0 });
      setCabinSelected(prev => !prev);
    } else if (payloadObj?.rooms?.length < 15) {
      handleCabinAdd(cabinInfo?.room_category_id);
      setCabinSelected(prev => !prev);
      } else snackbarCtx.toggleSnackbar({ message: 'Max cabins limit reached !', type: 'FAILURE', visible: true });
  };
  
  const handleCabinAdd = async (categoryId: string) => {
    if (payloadObj?.roomSelectionType === 'agent_selection' && payloadObj?.rooms.some((room: any) => !room?.selectedRoom?.deck_no || !room?.selectedRoom?.room_number) && !!addedCabinData.length) {
      snackbarCtx.toggleSnackbar({ message: 'Please select deck and room for all selected cabins!', type: 'FAILURE', visible: true });
      return;
    }

    handleAddRemoveCabinLoader(true);
    handleLastCabinUpdates(cabinInfo.room_category_id, false);

    //deck add logic
    // const data = await getAvailableDecks(payloadObj?.itineraryId, cabinInfo.room_category_id, 2,payloadObj.preference);
    // setAddedCabinDecksData([...addedCabinDecksData, { availableDecks: data?.result, selectedDeck: '' }]);
    
    const newCabinData = { categoryId, ...(specialPricingUpgradeOffer?.upgradeOffer && { fromCategoryId: cabinInfo.from_room_category_id }), guests: { adults: 2, children: 0, infants: 0 } };
    setAddedCabinData([...addedCabinData, newCabinData]);
    setCabinCategoryData({ ...cabinCategoryData, [cabinInfo.room_category_id]: [...addedCabinData, newCabinData] });
  };

  const handleCabinRemove = () => {
    if (!addedCabinData.length) {
      return;
    } else if (addedCabinData.length === 1) {
      setAddedCabinData([]);
      setCabinConfigurationCount({ three_seater: 0, four_seater: 0 });
      // setAddedCabinDecksData([]);
      // setAddedCabinDeckRoomsData([]);
      const { [cabinInfo.room_category_id]: delCabin, ...tempObj } = cabinCategoryData;
      setCabinCategoryData({ ...tempObj });
      return;
    };

    handleAddRemoveCabinLoader(true);

    //deck add logic
    // const updatedDeckData = [...addedCabinDecksData];
    // updatedDeckData.pop();
    // setAddedCabinDecksData([...updatedDeckData]);

    //room update logic
    // const tempDeckRoomsDataArr = [...addedCabinDeckRoomsData];
    // tempDeckRoomsDataArr.pop();
    // setAddedCabinDeckRoomsData([...tempDeckRoomsDataArr]);

    const updatedCabinData = [...addedCabinData];

    const lastRemovedCabin = updatedCabinData.pop();
    const { adults, children, infants } = lastRemovedCabin?.guests;
    const totalGuests = adults + children + infants;
    setCabinConfigurationCount((prev) => ({ ...prev,
      three_seater: totalGuests === 3 ? prev.three_seater - 1 : prev.three_seater,
      four_seater: totalGuests === 4 ? prev.four_seater - 1 : prev.four_seater }));
    
    setCabinCategoryData({ ...cabinCategoryData, [cabinInfo?.room_category_id]: [...updatedCabinData] });
    setAddedCabinData([...updatedCabinData]);
  };

  const handleGuestAdd = async (guestType: string, indexPosition: number) => {
    const guests = { ...addedCabinData[indexPosition]?.guests };
    const totalGuests = guests.adults + guests.children + guests.infants;
    const nextGuestCount = totalGuests + 1;
    const maxOccupancy = cabinInfo?.max_occupancy;
    const seatAvailability = { ...cabinInfo?.seat_availability };
    let message = '';
  
    if (guests.adults === 0 && guestType !== 'adults') {
      message = 'Add an adult first!';
    } else if (totalGuests === maxOccupancy) {
      message = `Only ${maxOccupancy} guests can be added to this cabin!`;
    } else if (guestType === 'infants' && guests.infants === 2) {
      message = 'Only 2 infants can be added to a cabin!';
    } else {
      if (nextGuestCount === 3 && Number(seatAvailability?.three_seater) + Number(seatAvailability?.four_seater) === cabinConfigurationCount.three_seater)
        message = 'Triple and quad occupancy cabins are full!';
      else if (nextGuestCount === 4 && Number(seatAvailability?.four_seater) === cabinConfigurationCount.four_seater) {
        message = 'Quad occupancy cabins are full!';
      };
    };
  
    if (message) {
      snackbarCtx.toggleSnackbar({ message, type: 'FAILURE', visible: true });
      return;
    };
  
    setCabinConfigurationCount((prev) => ({ ...prev,
      three_seater: nextGuestCount === 3 ? prev.three_seater + 1 : prev.three_seater,
      four_seater: nextGuestCount === 4 ? prev.four_seater + 1 : prev.four_seater }));
    //deck add logic
    // const data = await getAvailableDecks(payloadObj?.itineraryId, cabinInfo.room_category_id, Number(guests?.adults + guests?.children + guests?.infants + 1),payloadObj.preference);
    // const tempDeckDataArr = [...addedCabinDecksData];
    // tempDeckDataArr[indexPosition] = { availableDecks: data?.result, selectedDeck: '' };
    // setAddedCabinDecksData([...tempDeckDataArr]);

    //room update logic
    // const tempDeckRoomsDataArr = [...addedCabinDeckRoomsData];
    // tempDeckRoomsDataArr.splice(indexPosition, 1);
    // setAddedCabinDeckRoomsData([...tempDeckRoomsDataArr]);    

    const categoryId = addedCabinData[indexPosition]?.categoryId;
    const tempArr = [...addedCabinData];
    tempArr[indexPosition] = { categoryId: categoryId, ...(specialPricingUpgradeOffer?.upgradeOffer && { fromCategoryId: cabinInfo.from_room_category_id }), guests: { ...guests, [guestType]: guests[guestType] + 1 } };
    setAddedCabinData([...tempArr]);
    setCabinCategoryData({ ...cabinCategoryData, [cabinInfo.room_category_id]: [...tempArr] });
  }
    
  const handleGuestRemove = async (guestType: string, indexPosition: number) => {
    const guests = { ...addedCabinData[indexPosition]?.guests };
  
    if (guests[guestType] === 0) return;
  
    const categoryId = addedCabinData[indexPosition]?.categoryId;
    const totalGuests = guests.adults + guests.children + guests.infants;
  
    let updatedCabinData = [...addedCabinData];
  
    if (guestType === 'adults' && guests[guestType] === 1) {
      updatedCabinData.splice(indexPosition, 1);
      setCabinConfigurationCount((prev) => ({
        ...prev,
        three_seater: totalGuests === 3 ? prev.three_seater - 1 : prev.three_seater,
        four_seater: totalGuests === 4 ? prev.four_seater - 1 : prev.four_seater
      }));
    } else {
      updatedCabinData[indexPosition] = { categoryId, ...(specialPricingUpgradeOffer?.upgradeOffer && { fromCategoryId: cabinInfo.from_room_category_id }), guests: { ...guests, [guestType]: guests[guestType] - 1 } };
      const updatedTotalGuests = totalGuests - 1;
      setCabinConfigurationCount((prev) => ({ ...prev,
        three_seater: totalGuests === 3 ? prev.three_seater - 1 : updatedTotalGuests === 3 ? prev.three_seater + 1 : prev.three_seater,
        four_seater: totalGuests === 4 ? prev.four_seater - 1 : prev.four_seater }));
    };

    //deck update logic
    // const data = await getAvailableDecks(payloadObj?.itineraryId, cabinInfo.room_category_id, Number(guests?.adults + guests?.children + guests?.infants - 1),payloadObj.preference);
    // const tempDeckDataArr = [...addedCabinDecksData];
    // tempDeckDataArr[indexPosition] = { availableDecks: data?.result, selectedDeck: '' };
    // setAddedCabinDecksData([...tempDeckDataArr]);

    //room update logic
    // const tempDeckRoomsDataArr = [...addedCabinDeckRoomsData];
    // tempDeckRoomsDataArr.splice(indexPosition, 1);
    // setAddedCabinDeckRoomsData([...tempDeckRoomsDataArr]);
  
    setAddedCabinData([...updatedCabinData]);
    setCabinCategoryData({ ...cabinCategoryData, [cabinInfo.room_category_id]: [...updatedCabinData] });
  };

  // const handleDeckSelection = async (option: any, indexPosition: number) => {
  //   const tempDeckDataArr = [...addedCabinDecksData];
  //   tempDeckDataArr[indexPosition].selectedDeck = option.value;
  //   setAddedCabinDecksData([...tempDeckDataArr]);

  //   const data = await getAvailableDeckRooms(payloadObj?.itineraryId, cabinInfo.room_category_id, Number(addedCabinData[indexPosition].guests.adults + addedCabinData[indexPosition].guests.children + addedCabinData[indexPosition].guests.infants), option.value,payloadObj.preference);
  //   const tempDeckRoomsDataArr = [...addedCabinDeckRoomsData];
  //   tempDeckRoomsDataArr[indexPosition] = { availableRooms: data?.result, selectedRoomIndex: '' };
  //   setAddedCabinDeckRoomsData([...tempDeckRoomsDataArr]);
  // }

  // const handleDeckRoomSelection = async (option: any, indexPosition: number) => { 
  //   const deckRoomInfo = addedCabinDeckRoomsData[indexPosition]?.availableRooms[option.value];

  //   const tempDeckRoomsDataArr = [...addedCabinDeckRoomsData];
  //   tempDeckRoomsDataArr[indexPosition].selectedRoomIndex = option.value;
  //   setAddedCabinDeckRoomsData([...tempDeckRoomsDataArr]);

  //   const tempArr = [...addedCabinData];
  //   tempArr[indexPosition].selectedRoom = { ...deckRoomInfo };
  //   setAddedCabinData([...tempArr]);
  //   setCabinCategoryData({ ...cabinCategoryData, [cabinInfo.room_category_id]: [...tempArr] });
  // }

  const debouncedHandleCabinSelect = useCallback(
    debounce(handleCabinSelect, 400),
    [handleCabinSelect]
  );
  
  const debouncedHandleCabinRemove = useCallback(
    debounce(handleCabinRemove, 500),
    [handleCabinRemove]
  );

  const debouncedHandleCabinAdd = useCallback(
    debounce((cabinInfoId) => handleCabinAdd(cabinInfoId), 500),
    [handleCabinAdd]
  );

  const debouncedHandleGuestRemove = useCallback(
    debounce((guestType: string, indexPosition: number) => handleGuestRemove(guestType, indexPosition), 500),
    [handleGuestRemove]
  );

  const debouncedHandleGuestAdd = useCallback(
    debounce((guestType: string, indexPosition: number) => handleGuestAdd(guestType, indexPosition), 500),
    [handleGuestAdd]
  );

  const roomCount = useCallback(() => {
    if (specialPricingUpgradeOffer.specialPricing && specialPricingUpgradeOffer.upgradeOffer) {
      return (Number(cabinInfo?.sp_max_seats) - Number(cabinInfo?.booked_count)) >= 10;
    } else if (specialPricingUpgradeOffer.upgradeOffer) {
      return Number(cabinInfo?.p_max_seats) >= 10;
      // commented due to new flow of upgrade offer as we now get max seats directly from legacy app API
      // return (Number(cabinInfo?.p_max_seats) - Number(cabinInfo?.booked_count)) >= 10;
    } else {
      return Number(cabinInfo?.room_count) >= 10;
    }
  }, [specialPricingUpgradeOffer.specialPricing, specialPricingUpgradeOffer.upgradeOffer]);  
  
    return (
    <div className="flex flex-col cabin-detail-wrapper py-2">
      <div className="flex w-100" onClick={debouncedHandleCabinSelect}>
        <Col xs={12} sm={6}>
          <div className="cabin-view">
            <Form.Check
              type={"checkbox"}
              className="quotation-checkbox"
              checked={cabinSelected}
            />
            <DoubleBedIconSvg />
            <Form.Text className="input-label cabin">{cabinInfo?.category} </Form.Text>
          </div>
        </Col>
        <Col xs={12} sm={3} className="grid content-center">
          <span className={`input-label ${roomCount() ? 'text-[#17a300]' : 'text-[#d40d0d]'}`}>
            {roomCount() ? "More" : "Less"} than 10
          </span>
        </Col>
        <Col xs={12} sm={3}>
          <Form.Text className="input-label cabinPrice">₹{new Intl.NumberFormat("en-IN").format(Math.round(specialPricingUpgradeOffer?.specialPricing ? cabinInfo?.special_per_person :cabinInfo?.per_person))}</Form.Text>
        </Col>
      </div>
      {(!specialPricingUpgradeOffer?.upgradeOffer ? null : !!specialPricingUpgradeOffer?.specialPricing ? !!cabinInfo?.sp_desc : !!cabinInfo?.p_desc) && <span className="text-sm py-1 italic pl-6">{!specialPricingUpgradeOffer?.upgradeOffer ? null : !!specialPricingUpgradeOffer?.specialPricing ? cabinInfo?.sp_desc : cabinInfo?.p_desc}</span>}
      {cabinSelected && (
        <div className="flex w-100 my-2">
          <Col xs={4} sm={5} className="grid items-center">
            <span className="text-sm text-[#7a7a7a] font-normal ml-6">Add number of cabins required</span>
          </Col>
          <Col xs={4} sm={4} className="flex gap-3 justify-center items-center">
            <CustomButton fillColor={false} onButtonClick={debouncedHandleCabinRemove} disabled={addRemoveCabinLoader || !addedCabinData.length}
              clx="w-[30px] h-[30px] text-[#3a3a3a] text-xl bg-[#fff] border-2 border-[#aaa]">
              -
            </CustomButton>
            <span>{addedCabinData.length < 10 ? `0${addedCabinData.length}` : addedCabinData.length}</span>
            <CustomButton onButtonClick={() => debouncedHandleCabinAdd(cabinInfo?.room_category_id)} disabled={addRemoveCabinLoader || (payloadObj.rooms.length === 15) || ((specialPricingUpgradeOffer.specialPricing && specialPricingUpgradeOffer.upgradeOffer) ? (Number(cabinInfo?.sp_max_seats) - Number(cabinInfo?.booked_count)) === addedCabinData.length : specialPricingUpgradeOffer.upgradeOffer ? Number(cabinInfo?.p_max_seats) === addedCabinData.length : addedCabinData.length === Number(cabinInfo?.room_count))} clx="w-[30px] h-[30px] text-xl">
              +
            </CustomButton>
          </Col>
          <Col xs={4} sm={3} className="flex justify-end items-center">
            <span className="text-sm text-[#7a7a7a] font-normal ml-6">
              {addedCabinData.length < 10 ? `0${addedCabinData.length} cabin` : `${addedCabinData.length} cabins`} added
            </span>
          </Col>
        </div>
      )}
      {!!addedCabinData?.length &&
        addedCabinData?.map((data: any, index: number) => {
          return (
            <React.Fragment key={index}>
              <div className={`flex w-100 py-2.5 border-t-[1px] border-[#ddd] cabin-guest-wrapper ${addRemoveCabinLoader ? 'animate-pulse' : ''}`}>
                <Col xs={2} sm={2} className="grid items-center">
                  <span className="text-sm text-[#7a7a7a] font-normal ml-6">
                    Cabin {`${index + 1}`.padStart(2, '0')}
                  </span>
                </Col>
                <Col className="flex gap-2 items-center justify-center">
                  <span className="text-sm text-[#7a7a7a] font-normal">Adults</span>
                  <div className="flex items-center gap-2">
                    <CustomButton
                      fillColor={false} onButtonClick={() => debouncedHandleGuestRemove('adults', index)}
                      clx="flex items-center justify-center w-[24px] h-[24px] text-[#3a3a3a] text-xl bg-[#fff] border-2 border-[#aaa]"
                    >
                      -
                    </CustomButton>
                    <span>0{data?.guests?.adults}</span>
                    <CustomButton onButtonClick={() => debouncedHandleGuestAdd('adults', index)}
                    clx="flex items-center justify-center w-[24px] h-[24px] text-xl">+</CustomButton>
                  </div>
                </Col>
                <Col className="flex gap-2 items-center justify-center">
                  <span className="text-sm text-[#7a7a7a] font-normal">Children</span>
                  <div className="flex items-center gap-2">
                    <CustomButton
                      fillColor={false} onButtonClick={() => debouncedHandleGuestRemove('children', index)}
                      clx="flex items-center justify-center w-[24px] h-[24px] text-[#3a3a3a] text-xl bg-[#fff] border-2 border-[#aaa]"
                    >
                      -
                    </CustomButton>
                    <span>0{data?.guests?.children}</span>
                    <CustomButton onButtonClick={() => debouncedHandleGuestAdd('children', index)}
                    clx="flex items-center justify-center w-[24px] h-[24px] text-xl">+</CustomButton>
                  </div>
                </Col>
                <Col className="flex gap-2 items-center justify-end">
                  <span className="text-sm text-[#7a7a7a] font-normal">Infants</span>
                  <div className="flex items-center gap-2">
                    <CustomButton
                      fillColor={false} onButtonClick={() => debouncedHandleGuestRemove('infants', index)}
                      clx="flex items-center justify-center w-[24px] h-[24px] text-[#3a3a3a] text-xl bg-[#fff] border-2 border-[#aaa]"
                    >
                      -
                    </CustomButton>
                    <span>0{data?.guests?.infants}</span>
                    <CustomButton onButtonClick={() => debouncedHandleGuestAdd('infants', index)}
                    clx="flex items-center justify-center w-[24px] h-[24px] text-xl">+</CustomButton>
                  </div>
                </Col>
              </div>
              {/* {payloadObj?.roomSelectionType?.includes('agent') && !!data?.guests?.adults && <div className="flex justify-center gap-4 mt-1 pb-2.5 deck-room-wrapper">
                <div className="flex items-center gap-2.5">
                  <CustomSelect value={addedCabinDecksData[index]?.selectedDeck} onChange={(option) => handleDeckSelection(option, index)} placeholder="Select Deck"
                    label={"Deck"} options={addedCabinDecksData[index]?.availableDecks?.map((deckNumber: any) => ({
                      label: `Deck ${deckNumber.padStart(2,"0")}`,
                      value: Number(deckNumber),
                  })) || []} />
                </div>
                {!!addedCabinDecksData[index].selectedDeck && !!addedCabinDeckRoomsData[index]?.availableRooms?.length && <div className="flex items-center gap-2.5">
                <CustomSelect
                  value={addedCabinDeckRoomsData[index]?.selectedRoomIndex}
                  onChange={(option) => handleDeckRoomSelection(option, index)}
                  placeholder="Select Room"
                  label="Rooms"
                  options={(addedCabinDeckRoomsData[index]?.availableRooms || []).map((roomData: any, indexNo: number) => {
                    const isSelected = addedCabinDeckRoomsData.some((item: any, thisIndex: number) => {
                      return index !== thisIndex && item.selectedRoomIndex === indexNo;
                    });
                    if (!isSelected) {
                      return {
                        label: `Room ${roomData?.room_number}`,
                        value: indexNo,
                      };
                    }
                    return null;
                  }).filter((option: any) => option !== null)}
                />
                </div>}
              </div>} */}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default CabinCard;
